// src/components/ThemeInitializer.jsx
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { setTheme } from "../slices/ThemeSlice";

export default function ThemeInitializer() {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchGlobalTheme = async () => {
      try {
        const snapshot = await getDocs(collection(db, "Theme"));
        if (!snapshot.empty) {
          const doc = snapshot.docs[0]; // assuming only one settings doc
          const savedTheme = doc.data().theme || "#162f06";
          dispatch(setTheme(savedTheme));
        }
      } catch (err) {
        console.error("Failed to load theme:", err);
        // optional: dispatch default on error
        dispatch(setTheme("#162f06"));
      }
    };

    fetchGlobalTheme();
    // We only want to run once → no dependencies
  }, [dispatch]);

  return null; // This component renders nothing
}
